import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import ShowDescription from '../../../ShowDescription/ShowDescription';
import bt from '../../../commonStyle.css';

const JobDescription = ({ name, description }) => {
    return (
        <>
            <h1 className={cx(bt.commonSize18, bt.primaryColor, bt.fontWeight600, bt.spaceTop0, bt.space1)}>  {name} </h1>
            <ShowDescription description={description} count={500} className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor, bt.noMargin)} />
        </>
    )
}

const mapState = (state) => ({
    name: state.adminModalStatus.formData.name,
    description: state.adminModalStatus.formData.description
});

export default injectIntl(withStyles(bt)(connect(mapState, {})(JobDescription)));